export const reportFilterFields = [
    'accountNumber',
    'accountName',
    'accountType',
    'currentBalance',
    'availableBalance',
    'collectedBalance',
    'description',
    'checkImageNumber',
    'checkNumber',
    'debitAmount',
    'creditAmount',
    'balance',
    'transactionCode',
    'transactionCodeDescription',
    'ediAmount',
    'ediDate',
];
